import { connect } from 'react-redux';
import { compose, withPropsOnChange, withHandlers, withState } from 'recompose';
import withRouter from 'react-router/lib/withRouter';

import SubscriptionInvoices from '../components/SubscriptionInvoices';
import { getSubscriptionInvoices } from '../reducers/subscriptionInvoices';
import {
  fetchSubscriptionInvoices,
  refundSubscriptionInvoice,
  paySubscriptionInvoice,
  markSubscriptionInvoiceUncollectible,
} from '../actions';
import { getSubscriptionId } from '../reducers/subscription';
import confirmModal from '../../../common/confirmModal';
import { SUBSCRIPTION_INVOICE_ACTIONS } from '../constants';
import withToggle from '../../../common/hoc/withToggle';
import { showNotification } from '../../../common/helpers/notifications';

const mapStateToProps = state => ({
  subscriptionInvoices: getSubscriptionInvoices(state),
  subscriptionId: getSubscriptionId(state),
});

const mapDispatchToProps = {
  fetchSubscriptionInvoices,
  refundSubscriptionInvoice,
  paySubscriptionInvoice,
  markSubscriptionInvoiceUncollectible,
};

const getProcessData = (action) => {
  switch (action) {
    case SUBSCRIPTION_INVOICE_ACTIONS.pay:
      return {
        title: 'Charge invoice',
        message: 'Are you sure you want to charge this invoice?',
        method: 'paySubscriptionInvoice',
        successMessage: 'Invoice is successfully charged',
      };
    case SUBSCRIPTION_INVOICE_ACTIONS.markUncollectible:
      return {
        title: 'Mark invoice uncollectible',
        message: 'Are you sure you want to mark this invoice uncollectible?',
        method: 'markSubscriptionInvoiceUncollectible',
        successMessage: 'Invoice is successfully marked as uncollectible',
      };
    default:
      throw new Error('Unknown action requested');
  }
};

const enhance = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withToggle('refundModal'),
  withToggle('customAmount'),
  withState('selectedInvoice', 'setSelected', {}),
  withHandlers({
    refund: props => async (invoice, options) => {
      await props.refundSubscriptionInvoice(
        props.subscriptionId,
        invoice.id,
        options.amount
      );
      props.refundModalOff();
      props.setSelected({});
      showNotification({
        title: 'SUCCESS',
        message: invoice.maxRefundAmount < options.amount ?
          'Invoice partially refunded' :
          'Invoice was successfully refunded',
        level: 'success',
      });
    },
    processInvoice: props => async (invoiceId, action) => {
      const { title, message, successMessage, method } = getProcessData(action);
      const confirmed = await confirmModal({
        type: 'danger',
        title,
        message,
      });

      if (!confirmed) {
        return false;
      }

      await props[method](
        props.subscriptionId,
        invoiceId
      );

      showNotification({
        title: 'SUCCESS',
        message: successMessage,
        level: 'success',
      });
    },
  }),
  withPropsOnChange(['subscriptionId'], (props) => {
    if (props.subscriptionId) {
      return props.fetchSubscriptionInvoices(props.subscriptionId);
    }
  }),
);

export default enhance(SubscriptionInvoices);
